/**!
 * Created by Leonardo Cheslacki on 01/11/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import config from './../../../../config';

const {default: {api}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageWheel extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: [],
            disabled: false
        };

        this.$wheel = null;

        this.$current_frame = 1;

        this.$frame_response = 0;

        this.$end_frame = 3;

        _this = this;
    };

    $functions = {
        handleBack: function () {
            _this.$current_frame = 1;
            _this.getFrame().gotoAndPlay('complete');
        },

        /**
         *
         * @param event
         * @returns {*}
         */
        handleWheel: function (event) {
            if (_this.state.disabled) {
                return _this.stopPropagation(event);
            }

            _this.getForm(`${api.url}/wheel`, {}, {
                beforeSend: () => {
                    _this.state.disabled = true;
                },
                done: (response) => {
                    if (_this.verifyField(response, 'status')) {
                        _this.state.data = _this.verifyField(response, 'data.wheel_controller');

                        const {start, degrees, laps, duration, delay, answers} = _this.props;

                        _this.$wheel.rotation = start;

                        const tween = createjs.Tween.get(_this.$wheel);

                        let
                            {wheel: {answer}} = _this.randomArray(_this.state.data),
                            rotation = ((degrees * laps) + ((degrees / answers) * answer) + (degrees / 2));

                        tween.to({rotation: rotation}, duration, createjs.Ease.cubicOut).wait(delay).call((object) => {
                            object.paused = true;
                            _this.$wheel.rotation = rotation;

                            _this.submitWheel(answer, () => {
                                _this.state.disabled = false;
                            });
                        });
                        // console.log(response);
                    } else {
                        // console.log(response);
                    }
                },
                fail: (response) => {
                    console.log(response);
                },
                always: () => {

                }
            });
        }
    };

    /**
     *
     * @param answer
     * @param callback
     */
    submitWheel = (answer, callback) => {
        let wheel_controller = this.state.data.find(({wheel}) => ((wheel['answer'] === answer) && (wheel['type'] === 'win')));

        if (this.isObjectIf(wheel_controller)) {
            _this.postForm(`${api.url}/wheel`, {wheel_controller: {id: this.verifyField(wheel_controller, 'id')}}, {
                done: (response) => {
                    if (_this.verifyField(response, 'status')) {
                        // console.log(response);
                        _this.$current_frame = 3;
                        _this.$frame_response = wheel_controller.frame
                        _this.getFrame().gotoAndPlay('complete');
                    } else {
                        // console.log(response);
                    }
                },
                fail: (response) => {
                    console.log(response);
                },
                always: () => {
                    (typeof (callback) === 'function') && callback(wheel_controller);
                }
            });
        } else {
            (typeof (callback) === 'function') && callback(wheel_controller);
        }
    };

    startWheel = () => {
        const
            {start} = this.props,
            _this_current = this.get();

        this.main.on('animate_end', () => {

            this.gotoAndStopFrame(_this_current, this.$current_frame);

            const _this_frame = this.getFrame();

            _this_frame.gotoAndPlay('start');

            if (this.$current_frame === 3) {
                let {occ_response} = _this_frame;
                occ_response.gotoAndStop(`frame${this.padWithLeadingZeros(this.$frame_response, 2)}`);
            }

            if (this.$current_frame === 2) {
                let
                    {btn_start, occ_spin} = _this_frame,
                    handle_name_start = this.toHandleName('start', 'wheel');

                this.$wheel = occ_spin.occ_wheel;
                this.$wheel.rotation = start;

                this[handle_name_start] && btn_start.off('mousedown', this[handle_name_start]);
                this[handle_name_start] = btn_start.on('mousedown', this.$functions.handleWheel);
            }

            if (this.$current_frame === this.$end_frame) {
                let
                    {btn_back} = _this_frame,
                    handle_name_back = this.toHandleName('back', 'wheel');

                this[handle_name_back] && btn_back.off('mousedown', this[handle_name_back]);
                this[handle_name_back] = btn_back.on('mousedown', this.$functions.handleBack);
            }
        });
    };

    /**
     *
     */
    initWheel = () => {
        const
            {totalFrames} = this.get(),
            {btn_init} = this.getFrame();

        this.$end_frame = (totalFrames - 1);

        let handle_name_init = this.toHandleName('init', 'wheel');

        this[handle_name_init] && btn_init.off('mousedown', this[handle_name_init]);
        this[handle_name_init] = btn_init.on('mousedown', () => {
            this.$current_frame = 2;
            this.getFrame().gotoAndPlay('complete');
        });

        this.startWheel();
    };
}

/**
 *
 * @type {{}}
 */
StageWheel.propTypes = {
    start: PropTypes.number,
    degrees: PropTypes.number,
    laps: PropTypes.number,
    duration: PropTypes.number,
    delay: PropTypes.number,
    answers: PropTypes.number
};

/**
 *
 * @type {{}}
 */
StageWheel.defaultProps = {
    start: 0,
    degrees: 360,
    laps: 20,
    duration: 20000,
    delay: 500,
    answers: 8
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageWheel, {className: 'StageWheel'});
